module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/XWK6NN/tc-custom/9781426877339.jpg?1705766123660",
      "alt": "This image is the cover for the book Latin Lover's Secret Child, The Galvan Brides"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Latin Lover's Secret Child, The Galvan Brides\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Argentinean wine tycoon Lucio Cruz is not expecting the call that summons him to his estranged wife's side. She's suffering a partial loss of memory, and Lucio discovers that she's returned to being the fiery, affectionate girl with whom he once eloped. Suddenly he can't resist her--but he knows he must. In just a few weeks, their divorce will be final.... "), _c('br'), _c('br'), _vm._v("Unless Ana can recall a secret that could change both their lives...")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jane Porter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jane Porter loves central California's golden foothills and miles of farmland, rich with the sweet and heady fragrance of orange blossoms. Her parents fed her imagination by taking Jane to Europe for a year where she became passionate about Italy and those gorgeous Italian men! Jane never minds a rainy day – that's when she sits at her desk and writes stories about far-away places, fascinating people, and most important of all, love. Visit her website at: www.janeporter.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0